"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SolutionAnnouncementType = exports.SolutionAnnouncementScope = exports.PlatFormAnnouncementType = exports.AttachmentTypeEnum = exports.AnnouncementAppMode = void 0;
let AnnouncementAppMode = exports.AnnouncementAppMode = /*#__PURE__*/function (AnnouncementAppMode) {
  AnnouncementAppMode["Platform"] = "platform";
  AnnouncementAppMode["Solution"] = "solution";
  return AnnouncementAppMode;
}({});
let AttachmentTypeEnum = exports.AttachmentTypeEnum = /*#__PURE__*/function (AttachmentTypeEnum) {
  AttachmentTypeEnum[AttachmentTypeEnum["Unknown"] = 0] = "Unknown";
  AttachmentTypeEnum[AttachmentTypeEnum["Excel"] = 1] = "Excel";
  AttachmentTypeEnum[AttachmentTypeEnum["PDF"] = 2] = "PDF";
  AttachmentTypeEnum[AttachmentTypeEnum["JPEG"] = 3] = "JPEG";
  AttachmentTypeEnum[AttachmentTypeEnum["PNG"] = 4] = "PNG";
  AttachmentTypeEnum[AttachmentTypeEnum["SVG"] = 5] = "SVG";
  AttachmentTypeEnum[AttachmentTypeEnum["MP4"] = 6] = "MP4";
  AttachmentTypeEnum[AttachmentTypeEnum["WEBM"] = 7] = "WEBM";
  AttachmentTypeEnum[AttachmentTypeEnum["POWERPOINT"] = 8] = "POWERPOINT";
  AttachmentTypeEnum[AttachmentTypeEnum["WORD"] = 9] = "WORD";
  AttachmentTypeEnum[AttachmentTypeEnum["Text"] = 10] = "Text";
  return AttachmentTypeEnum;
}({});
let SolutionAnnouncementScope = exports.SolutionAnnouncementScope = /*#__PURE__*/function (SolutionAnnouncementScope) {
  SolutionAnnouncementScope["Cloud"] = "cloud";
  SolutionAnnouncementScope["Application"] = "application";
  SolutionAnnouncementScope["Portal"] = "portal";
  SolutionAnnouncementScope["Model"] = "model";
  SolutionAnnouncementScope["ModelPart"] = "modelpart";
  return SolutionAnnouncementScope;
}({});
let SolutionAnnouncementType = exports.SolutionAnnouncementType = /*#__PURE__*/function (SolutionAnnouncementType) {
  SolutionAnnouncementType["Maintenance"] = "maintenance";
  SolutionAnnouncementType["Feature"] = "feature";
  return SolutionAnnouncementType;
}({});
let PlatFormAnnouncementType = exports.PlatFormAnnouncementType = /*#__PURE__*/function (PlatFormAnnouncementType) {
  PlatFormAnnouncementType["Maintenance"] = "maintenance";
  PlatFormAnnouncementType["Feature"] = "feature";
  return PlatFormAnnouncementType;
}({});